export default {
  auth: () => import("/app/layouts/auth.vue"),
  dashboard: () => import("/app/layouts/dashboard.vue")
}